import { getGlobalLocalesForUiSelect } from "./builtinResources";

/**
 * Parâmetros de query aceitos (campanhas / links externos).
 * Ordem de precedência: o primeiro parâmetro presente na lista abaixo vence.
 */
export const UI_LANG_URL_PARAMS = ["lang", "locale", "lng", "ui_lang"];

function allowedUiLocaleCodes() {
  return getGlobalLocalesForUiSelect().map((x) => x.code);
}

/**
 * Extrai e valida código BCP-47 da query string (?lang=es&...).
 * @param {string} search - location.search ou string com/sem "?"
 */
export function parseUiLocaleFromSearch(search) {
  if (search == null || typeof search !== "string") return null;
  const normalized = search.startsWith("?") ? search : `?${search}`;
  let params;
  try {
    params = new URLSearchParams(normalized);
  } catch {
    return null;
  }

  const allowed = allowedUiLocaleCodes();
  if (!allowed.length) return null;

  for (const key of UI_LANG_URL_PARAMS) {
    const raw = params.get(key);
    if (raw == null || raw === "") continue;
    const code = String(raw).trim();
    if (!code) continue;

    if (allowed.includes(code)) return code;

    const lower = code.toLowerCase();
    const exactCi = allowed.find((c) => c.toLowerCase() === lower);
    if (exactCi) return exactCi;

    const byPrefix = allowed.find(
      (c) =>
        lower.startsWith(`${c.toLowerCase()}-`) || lower.startsWith(`${c.toLowerCase()}_`)
    );
    if (byPrefix) return byPrefix;
  }

  return null;
}
